import { render, staticRenderFns } from "./chatListChat.vue?vue&type=template&id=460ce563&"
import script from "./chatListChat.vue?vue&type=script&lang=ts&"
export * from "./chatListChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports